import { useTranslation } from 'react-i18next';
import { Flex, Image } from '@mafc/trolly';

import PciDssLogo from 'assets/pci-dss.png';
import SecureCodeLogo from 'assets/securecode.png';
import VerifiedByVisaLogo from 'assets/verified-by-visa.png';

import * as S from './SecurePaymentsLogo.style';

const SecurePaymentsLogo = () => {
  const { t } = useTranslation();
  return (
    <S.SecurePaymentsLogo>
      <S.Heading>{t('securePayment')}</S.Heading>

      <Flex>
        <S.IconWrapper>
          <Image url={PciDssLogo} name="pci dss" width={52} />
        </S.IconWrapper>
        <S.IconWrapper>
          <Image url={SecureCodeLogo} name="secure-code" width={68} />
        </S.IconWrapper>
        <S.IconWrapper>
          <Image url={VerifiedByVisaLogo} name="verified-by-visa" width={42} />
        </S.IconWrapper>
      </Flex>
    </S.SecurePaymentsLogo>
  );
};

export default SecurePaymentsLogo;
